import { NgModule, Component, Input, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common'
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';


@Component({
    selector: 'season-list',
    templateUrl: 'season-list.template.html',
    styleUrls: ['season-list.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SeasonList {
    @Input() item: any;
    @Input() enablePlayAll: boolean;

    get slides(){
        let _slides = null;

        if(this.item && this.item.data)
        {
            _slides = this.item.data;

            if(_slides.length >= 1 && _slides[0].meta.obj_type == "Season")
            {
                _slides[0].meta.internal_route = this.item.internal_route;
            }
        }

        return _slides;
    }

    private subs: any;
    /**
     * seasonList component
     */
    constructor(private coreEffects: CoreEffects, private cd: ChangeDetectorRef, ) {
    }

}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/series/season-list/season-list.component.ts